import React from "react";
import { Redirect } from "react-router-dom";

// Authentication related pages
import Login from "../page/Authentication/Login";
import ForgotPassword from "../page/Authentication/ForgotPassword";
import VerifyPassword from "../page/Authentication/VerifyPassword";
import LoginSSO from "../page/Authentication/loginSSO";
import VerifyLogin from "../page/Authentication/VerifyLogin";

// Dashboard
import Dashboard from "../page/Dashboard/index";

// Real pages
import Faq from "../page/faq/index";
import Privacy from "../page/privacy/index";
import Terms from "../page/terms/index";
import Settings from "../page/settings/index";
import Contactus from "../page/contactus/index";
import Enquiries from "../page/enquiries/index";
import Career from "../page/career/index";

// Downloads
import Downloads from "../page/downloads/index";
import DownloadCategoryList from "../page/downloads/categoryList";
import DownloadList from "../page/downloads/list";
import CreateDownload from "../page/downloads/createDownload";
import EditDownload from "../page/downloads/editDownload";

// Social News
import Social from "../page/socialNews/index";
import SocialCategoryList from "../page/socialNews/categoryList";
import SocialList from "../page/socialNews/list";
import CreateSocialNews from "../page/socialNews/createSocialNews";
import EditSocialNews from "../page/socialNews/editSocialNews";

// Jobs
import JobCategory from "../page/job/category";
import Jobs from "../page/job/Jobs";
import CreateJob from "../page/job/create";
import EditJob from "../page/job/Edit";
import JobApplications from "../page/job/Applications";
import HomePage from "../page/homepage/index";
import Aboutus from "../page/aboutus/index";
import Events from "../page/events/index";
import Stats from "../page/stats/index";
import Team from "../page/team/index";
import Features from "../page/features/index";
import CreateFeature from "../page/features/create";
import EditFeature from "../page/features/edit";
import Solutions from "../page/solutions/index";
import CreateSolution from "../page/solutions/create";
import EditSolution from "../page/solutions/edit";
import Customer from "../page/customer/index";
import Profile from "../page/profile/index";
import StaffList from "../page/staff/index";
import ChangePassword from "../page/profile/ChangePassword";
import Tools from "../page/tools/index";
import Roles from "../page/roles/index";
import GeneralEnquiries from "../page/generalEnquiries/index";

import TalkToUs from "../page/talktous/index";
import CommonSettings from "../page/common/index";

const authProtectedRoutes = [
  { path: "/dashboard", component: Dashboard },

  // * * * Real pages * * *
  // Todo: Faq
  { path: "/faq", component: Faq },
  { path: "/talktous", component: TalkToUs },
  { path: "/privacy", component: Privacy },
  { path: "/terms", component: Terms },
  { path: "/settings", component: Settings },
  { path: "/contactus", component: Contactus },
  { path: "/enquiries", component: Enquiries },
  { path: "/career", component: Career },
  // Todo: Downloads
  { path: "/downloads", exact: true, component: Downloads },
  { path: "/downloads/category", exact: true, component: DownloadCategoryList },
  { path: "/downloads/list", exact: true, component: DownloadList },
  { path: "/downloads/list/create", exact: true, component: CreateDownload },
  { path: "/downloads/list/edit/:id", exact: true, component: EditDownload },

  // Todo: Social News
  { path: "/social", exact: true, component: Social },
  { path: "/social/category", exact: true, component: SocialCategoryList },
  { path: "/social/list", exact: true, component: SocialList },
  { path: "/social/list/create", exact: true, component: CreateSocialNews },
  { path: "/social/list/edit/:id", exact: true, component: EditSocialNews },

  // Todo: Common Settings
  { path: "/common", exact: true, component: CommonSettings },

  // Todo: Job
  { path: "/jobs/category", exact: true, component: JobCategory },
  { path: "/jobs", exact: true, component: Jobs },
  { path: "/jobs/create", exact: true, component: CreateJob },
  { path: "/jobs/edit/:id", exact: true, component: EditJob },
  { path: "/jobs/applications", exact: true, component: JobApplications },

  // Todo: Homepage
  { path: "/homepage", exact: true, component: HomePage },
  { path: "/aboutus", exact: true, component: Aboutus },
  { path: "/events", exact: true, component: Events },
  { path: "/stats", exact: true, component: Stats },
  { path: "/team", exact: true, component: Team },
  { path: "/customers", exact: true, component: Customer },
  // Todo: Features
  { path: "/features", exact: true, component: Features },
  { path: "/features/create", exact: true, component: CreateFeature },
  { path: "/features/edit/:id", exact: true, component: EditFeature },

  // Todo: Solutions
  { path: "/solutions", exact: true, component: Solutions },
  { path: "/solutions/create", exact: true, component: CreateSolution },
  { path: "/solutions/edit/:id", exact: true, component: EditSolution },

  // Todo: Profile
  { path: "/profile", exact: true, component: Profile },
  { path: "/change-password", exact: true, component: ChangePassword },

  // Todo: Staff
  { path: "/staff", exact: true, component: StaffList },

  // Todo: Tools
  { path: "/tools", exact: true, component: Tools },

  // Todo: Roles
  { path: "/roles", exact: true, component: Roles },

  // Todo: GeneralEnquiries
  { path: "/general-enquiries", exact: true, component: GeneralEnquiries },

  // this route should be at the end of all other routes
  { path: "/", exact: true, component: Dashboard },
];

const publicRoutes = [
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgotPassword },
  { path: "/verify-password", component: VerifyPassword },
  { path: "/login-sso", component: LoginSSO },
  { path: "/verify-login", component: VerifyLogin },
  // { path: "/logout", component: Logout },
  // { path: "/forgot-password", component: ForgetPwd },
  // { path: "/register", component: Register },
  // { path: "/lock-screen", component: AuthLockScreen },

  // // Authentication Inner
  // { path: "/auth-login", component: Login1 },
  // { path: "/auth-register", component: Register1 },
  // { path: "/auth-recoverpw", component: ForgetPwd1 },

  // { path: "/maintenance", component: Maintenance },
  // { path: "/comingsoon", component: CommingSoon },
  // { path: "/404", component: Error404 },
  // { path: "/500", component: Error500 },
  // { path: "/", exact: true, component: Login },
  { path: "/", exact: true, component: Login },
];

export { authProtectedRoutes, publicRoutes };
